export default "__VITE_ASSET__38874cf3__"